import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actionCreators } from "../../store/KPI";
import {bindActionCreators} from "redux";

class KPISettingsMenu extends Component{
  constructor(props) {
    super(props);
    
    this.state = {};
    
    this.handleSet = this.handleSet.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  handleSet(event){
    const kpi_id = event.currentTarget.getAttribute("id");
    this.props.setUserKPI(kpi_id);
  }
  
  handleRemove(event){
    const kpi_id = event.currentTarget.getAttribute("id");
    this.props.removeUserKPI(kpi_id);
  }

  render(){
    return(
      <div className="flex-column kpi-container">

        <div className="">
          <div className="kpi-title">
            <h3>Your KPI</h3>
          </div>
          <div className="kpi-user-settings-body">
            <div className="kpi-user-settings">
              {this.props.userKPI.map( (type) => {
                return(
                  <div key={type.key}>
                    {type.value.map( (kpi) =>{
                      return(
                        <button 
                          key={kpi.id}
                          type="button" name="button" className="button-option-remove"
                          id={kpi.id}
                          onClick={this.handleRemove}
                          style={{margin: '8px', display: 'unset'}}
                        > {kpi.type} - {kpi.name}</button>
                      )
                    })}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        
        <div className="">
          <div className="kpi-title">
            <h3>Add KPI</h3>
          </div>
          <div className="flex-row kpi-settings-body">
            {this.props.options.map( (type) => {
              return(
                <div key={type.key} className="flex-column kpi-settings-item">
                  <div className="kpi-title">
                    <h3>{type.key}</h3>
                  </div>
                  <div className="flex-row flex-wrap">
                    {type.value.map( (kpi) => {
                      return(
                        <button className="button-option-add" 
                                key={kpi.id} 
                                id={kpi.id} 
                                onClick={this.handleSet}
                                style={{margin: '8px', display: 'unset'}}
                        > 
                          + {kpi.name} 
                        </button>
                      )
                    })}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    );
  };

}

export const mapStateToProps = function(state) {
  return {
    user: state.oidc.user,
    kpi: state.kpi,
    options: state.kpi.options,
    userKPI: state.kpi.data
  }
};

export default connect(
  mapStateToProps,
  dispatch => bindActionCreators(actionCreators, dispatch)
)(KPISettingsMenu);